import React, {FC} from "react"
import {useIntl} from "@irati/utils/lang"
import {CashbackTransactionStatus, Wallet} from "@irati/types"
import {useCashbackTransactionTotalAmount} from "@irati/cashback/hooks/cashback"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import Spacing from "@irati/ui/src/Spacing"
import NoData from "../../NoData/NoData"
import {Transactions} from "./Transactions"
import {CashbackHistory} from "./CashbackHistory"

interface Props {
  wallet: Wallet
}

const CashbackTransactions: FC<Props> = ({wallet}) => {
  const {formatMessage} = useIntl()
  const userId = useAuth().user?.uuid ?? ""

  const {data: pendingTotalAmount} = useCashbackTransactionTotalAmount({
    userId,
    status: CashbackTransactionStatus.StatusPending,
    currency: wallet?.currency
  })

  const hasZeroState = wallet?.amount === 0 && pendingTotalAmount?.amount === 0

  if (hasZeroState) {
    return (
      <Spacing marginTop={4}>
        <NoData useCardStyle text={formatMessage({id: "wallet.reward.noScheduledTransfers.text"})} />
      </Spacing>
    )
  }

  return (
    <Spacing marginTop={4}>
      <Transactions status={CashbackTransactionStatus.StatusPending} />
      <CashbackHistory wallet={wallet} />
    </Spacing>
  )
}

export {CashbackTransactions}
